import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TextInputComponent } from "./form-field/text-input/text-input.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzInputModule } from "ng-zorro-antd/input";
import { CountryCodeTextInputComponent } from "./form-field/country-code-text-input/country-code-text-input.component";
import { NzSelectModule } from "ng-zorro-antd/select";
import { OnlynumericDirective } from "../directives/onlynumeric.directive";
import { UserAvatarComponent } from "./common-components/user-avatar/user-avatar.component";
import { AvatarInfoPopoverComponent } from "./common-components/avatar-info-popover/avatar-info-popover.component";
import { IconComponent } from "./common-components/icon/icon.component";
import { IconGalleryComponent } from "./common-components/icon-gallery/icon-gallery.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { TextAreaComponent } from "./form-field/text-area/text-area.component";
import { DatePickerComponent } from "./form-field/date-picker/date-picker.component";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { TimePickerComponent } from "./form-field/time-picker/time-picker.component";
import { NzTimePickerModule } from "ng-zorro-antd/time-picker";
import { OnboardingComponent } from "./common-components/onboarding/onboarding.component";
import { SelectInputComponent } from "./form-field/select-input/select-input.component";
import { NoRecordFoundComponent } from "./common-components/no-record-found/no-record-found.component";
import { DesignElementsGalleryComponent } from "./common-components/design-elements-gallery/design-elements-gallery.component";
import { AssetPipelineMiniComponent } from "./common-components/asset-pipeline-mini/asset-pipeline-mini.component";
import { AudioPlayerComponent } from "./common-components/audio-player/audio-player.component";
import { InlineJobLoadingComponent } from "./common-components/inline-job-loading/inline-job-loading.component";
import { ImagePreviewOverlayComponent } from "./common-components/image-preview-overlay/image-preview-overlay.component";
import { JobCancelButtonComponent } from "./common-components/job-cancel-button/job-cancel-button.component";
import { JobEtaComponent } from "./common-components/job-eta/job-eta.component";
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpinModule } from 'ng-zorro-antd/spin';
@NgModule({
  declarations: [
    TextInputComponent,
    CountryCodeTextInputComponent,
    UserAvatarComponent,
    AvatarInfoPopoverComponent,
    IconGalleryComponent,
    TextAreaComponent,
    DatePickerComponent,
    TimePickerComponent,
    OnboardingComponent,
    SelectInputComponent,
    NoRecordFoundComponent,
    DesignElementsGalleryComponent,
    AssetPipelineMiniComponent,
    InlineJobLoadingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzSelectModule,
    OnlynumericDirective,
    NzModalModule,
    NzDatePickerModule,
    NzTimePickerModule,
    NzTooltipModule,
    NzDropDownModule,
    NzMenuModule,
    NzSpinModule,
    AudioPlayerComponent,
    IconComponent,
    ImagePreviewOverlayComponent,
    JobCancelButtonComponent,
    JobEtaComponent,
  ],
  exports: [
    DesignElementsGalleryComponent,
    TextInputComponent,
    CountryCodeTextInputComponent,
    OnlynumericDirective,
    UserAvatarComponent,
    AvatarInfoPopoverComponent,
    IconComponent,
    TextAreaComponent,
    DatePickerComponent,
    TimePickerComponent,
    SelectInputComponent,
    NoRecordFoundComponent,
    AssetPipelineMiniComponent,
    AudioPlayerComponent,
    InlineJobLoadingComponent,
    ImagePreviewOverlayComponent,
    JobCancelButtonComponent,
    JobEtaComponent,
  ],
})
export class SharedModule {}
